import {Pipe, PipeTransform} from '@angular/core';
import {AUTHORISATION_TASK_STATUSES_ENUM} from '../../../shared/constants/diagram-authorisation.constants';

@Pipe({
  name: 'authorisationTaskStatus',
  standalone: true
})
export class AuthorisationTaskStatusPipe implements PipeTransform {
  transform(status): any {
    let resultStr = status;

    switch (status) {
      case AUTHORISATION_TASK_STATUSES_ENUM.IN_PROGRESS:

      case AUTHORISATION_TASK_STATUSES_ENUM.NOT_STARTED:
        resultStr = 'TOOLBAR.AUTHORISATION_TASK_STATUS_PENDING';
        break;

      case AUTHORISATION_TASK_STATUSES_ENUM.COMPLETED:
        resultStr = 'TOOLBAR.AUTHORISATION_TASK_STATUS_AUTHORIZED';
        break;

      case AUTHORISATION_TASK_STATUSES_ENUM.READY_TO_APPROVE:
        resultStr = 'TOOLBAR.AUTHORISATION_TASK_STATUS_ACCEPTED';
        break;

      case AUTHORISATION_TASK_STATUSES_ENUM.REJECTED:
        resultStr = 'TOOLBAR.AUTHORISATION_TASK_STATUS_REJECTED';
        break;

      case AUTHORISATION_TASK_STATUSES_ENUM.CANCELED:
        resultStr = 'TOOLBAR.AUTHORISATION_TASK_STATUS_CANCELED';
        break;

      default:
        break;
    }

    return resultStr;
  }
}
